import { Paper } from "@mui/material";
import React from "react";
import { useMapMode } from "../../../../utils/router";
import { LevelSelector } from "./LevelSelector";
import { ScenarioSelector } from "./ScenarioSelector";
export const Selectors: React.FC = () => {
  const mode = useMapMode();
  return (
    <Paper
      sx={{
        position: "absolute",
        width: "fit-content",
        zIndex: 8,
        bottom: { xs: 0, md: "auto" },
        left: { xs: "auto", md: 0 },
        right: { xs: 0, md: 0 },
        top: { xs: "auto", md: 0 },
        columnGap: { xs: ".5rem", md: ".5rem" },
        display: "flex",
        flexDirection: { md: "column", xs: "row" },
        px: "1rem",
        m: ".25rem",
        alignItems: { xs: "end", md: "start" },
        py: ".5rem",
        borderRadius: ".5rem",
        backdropFilter: "blur(4px)",
        backgroundColor: "#FFFFFF80",
      }}
    >
      <LevelSelector />
      {mode === "edit" ? null : <ScenarioSelector />}
    </Paper>
  );
};
